import { LOGOUT_SUCCESS } from "../../../constants/actionTypes"

export default (payload) => (dispatch) => {
    dispatch({
        type: LOGOUT_SUCCESS,
        payload: payload
    })
}